import React from "react"
import styled from "styled-components"

const ProductHeaderTable = (props) => {
  const { productLabels, id } = props

  return (
    <StyledProductHeader>
      <StyledInner>
        <h2>{id}</h2>
        <StyledProductTable>
          <p>{productLabels["Product Image"]}</p>
          <p>{productLabels["Item name"]}</p>
          <p>{productLabels["Pack QTY"]}</p>
          <p>{productLabels["RRP"]}</p>
          <p>{productLabels["Trade cost"]}</p>
          <p>{productLabels["Quantity"]}</p>
        </StyledProductTable>
      </StyledInner>
    </StyledProductHeader>
  )
}
export default ProductHeaderTable

const StyledProductHeader = styled.div`
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
  padding-bottom: 0;
`

const StyledProductTable = styled.div`
  color: #e4032d;
  display: grid;
  grid-template-columns:
    120px
    calc((100% - 120px) * 2 / 6)
    calc((100% - 120px) * 1 / 6)
    calc((100% - 120px) * 1 / 6)
    calc((100% - 120px) * 1 / 6)
    calc((100% - 120px) * 1 / 6);
  table-layout: fixed; /* Ensures consistent column widths */
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas: ". . . .";
  border-bottom: solid 1px #e2e2e2;

  @media (max-width: 540px) {
    & > *:first-child {
      display: none; /* Hide the first child (product image) */
    }

    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  }

  p {
    color: #e4032d;
    margin-bottom: 10px;
    margin-top: 0;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    padding-right: 8px;
  }
`

const StyledInner = styled.div`
  @media (max-width: 540px) {
    display: none; /* Hide the component on small screens */
  }
`
